
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b8a24bde&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Profile2.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./Profile2.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b8a24bde!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Profile2.vue"),
  /* scopeId */
  "data-v-b8a24bde",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Users/Profile/Profile2.vue
// module id = 677
// module chunks = 0